export default "__VITE_PUBLIC_ASSET__066fc827__"